import { NgModule } from "@angular/core";
import { CommonModule} from '@angular/common';


import {CollapseComponent} from './home-work-collapse/collapse.component';
import {ItemComponent} from './home-work-item/item.component';
import {SharedModule} from '../../component/shareModule';
import {ExerciseFinishComponent} from './home-work-finish/finish.component';
import {PreviewComponent} from './home-work-preview/preview.component';

@NgModule({
  imports: [CommonModule, SharedModule],
    declarations:[
      CollapseComponent,
      ItemComponent,
      PreviewComponent,
      ExerciseFinishComponent,
    ],
    exports:[
      CollapseComponent,
      ItemComponent,
      PreviewComponent,
      ExerciseFinishComponent,
    ]
})

export class HomeWorkModule{

}




// WEBPACK FOOTER //
// ./src/app/app-home-work/home-work.module.ts